import {
    AgentChannelType,
    NullOr,
    Recording,
    RecordingMoment,
    RecordingMomentRoles,
    Tracker,
    TrackerWithAiIndicator,
} from "@regal-voice/shared-types";

type CustomAnalysisValidPrimitives = string | number | boolean | null;

export type RecordingCustomAiAnalysis = {
    [key: string]: CustomAnalysisValidPrimitives | { [key: string]: CustomAnalysisValidPrimitives };
};

export interface EnhancedRecordingMoment extends RecordingMoment {
    speakerName: string;
    role: RecordingMomentRoles;
    monitoring?: boolean;
    trackers?: Tracker[];
    trackersWithAiIndicator?: TrackerWithAiIndicator[];
    isBackchannel?: boolean;
}

export interface RecordingDetails extends Recording {
    customCallAnalysis: NullOr<CallAnalysisEvent>;
    moments: EnhancedRecordingMoment[];
    trackers: Tracker[];
    callSummary?: string;
    aiAgent?: {
        id: string;
        version: number;
        name: string;
        internalName: string;
        agentChannelType: AgentChannelType;
        composedName: string;
        variant?: {
            id: string;
            name: string;
        };
    };
}

export type CallAnalysisEvent = {
    event_type: string;
    key: string;
    name: string;
    properties: CallAnalysisEventProperties;
};

type CallAnalysisEventProperties = {
    agent_email: string;
    agent_fullname: string;
    call_analysis: RecordingCustomAiAnalysis;
    outgoing_sip_headers: Record<string, any>;
    task_id: string;
};

// ENUM CLEAN UP
// eslint-disable-next-line no-restricted-syntax
export enum TranscriptTabs {
    CALL_DETAILS,
    SEARCH,
    SCORECARDS,
}

export type TranscriptionItemUrl = {
    params: TranscriptionItemParams;
    searchParams: URLSearchParams;
};

export type TranscriptionItemParams = {
    taskSid?: string;
    recordingSid: string;
    contactPhone?: string;
};

export const TranscriptionFilter = [
    "contactSentiment",
    "agentSentiment",
    "campaignName",
    "doesHaveTranscript",
    "handlingAgent",
    "dispositions",
    "callDuration",
    "trackers",
    "overallScore",
    "scoredByTemplate",
    "notScoredByTemplate",
    "taskType",
    "missingTrackers",
] as const;
